import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export enum Theme {
    Light = 'light-theme',
    Dark = 'dark-theme',
}

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    public isDarkMode = false;
    private themeClass: Theme | null = Theme.Light;
    private renderer: Renderer2;

    constructor(private rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public get appliedTheme(): Theme {
        /* CSS-wise, Light Theme has priority */
        return this.themeClass || Theme.Light;
    }

    public changeTheme(theme: Theme): void {
        this.isDarkMode = theme === Theme.Dark;
        if (this.themeClass !== null) {
            this.renderer.removeClass(this.document.body, this.themeClass);
        }

        this.renderer.addClass(this.document.body, theme);
        this.renderer.setAttribute(document.documentElement, 'data-theme', theme);
        this.themeClass = theme;
    }
}
